import { ListInstallmentsQuery } from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import { removeMask } from '@/utils/mask';
import { DateTimeFormat } from '@/utils/moment';
import { Button, Form, Modal, ModalProps } from 'antd';
import moment, { Moment } from 'moment';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import FilterByDatesFields from './FilterByDatesFields';
import RegisterDataAccountPayable from './RegisterDataAccountPayable';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: () => void;
  handleSetFilter: (values: ListInstallmentsQuery) => void;
  queryParams?: ListInstallmentsQuery;
}

export interface InstallmentsAdvancedFilterFormValues {
  cnpjCreditor: string;
  purchaseCode: string;
  purchasingDocumentNumber: string;
  documentNumber: string;
  bankAccountId: number;
  costCenterId: number;
  initialDueDate: Moment;
  finalDueDate: Moment;
  initialPayDate: Moment;
  finalPayDate: Moment;
  initialEmissionDate: Moment;
  finalEmissionDate: Moment;
}

const InstallmentsAdvancedModalFilters: React.FC<Props> = ({
  open,
  onCancel,
  handleSetFilter,
  queryParams,
}) => {
  const [form] = Form.useForm<InstallmentsAdvancedFilterFormValues>();

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const onCallback = async () => {
    const values = await form.validateFields();

    handleSetFilter({
      ...values,
      cnpjCreditor: removeMask(values.cnpjCreditor),
      initialDueDate: values?.initialDueDate?.format(DateTimeFormat),
      finalDueDate: values?.finalDueDate?.format(DateTimeFormat),
      initialPayDate: values?.initialPayDate?.format(DateTimeFormat),
      finalPayDate: values?.finalPayDate?.format(DateTimeFormat),
      initialEmissionDate: values?.initialEmissionDate?.format(DateTimeFormat),
      finalEmissionDate: values?.finalEmissionDate?.format(DateTimeFormat),
    });

    onCancel();
  };

  useEffect(() => {
    if (queryParams) {
      form.setFieldsValue({
        ...queryParams,
        initialDueDate:
          queryParams.initialDueDate && moment(queryParams.initialDueDate),
        finalDueDate:
          queryParams.finalDueDate && moment(queryParams.finalDueDate),
        initialPayDate:
          queryParams.initialPayDate && moment(queryParams.initialPayDate),
        finalPayDate:
          queryParams.finalPayDate && moment(queryParams.finalPayDate),
        initialEmissionDate:
          queryParams.initialEmissionDate &&
          moment(queryParams.initialEmissionDate),
        finalEmissionDate:
          queryParams.finalEmissionDate &&
          moment(queryParams.finalEmissionDate),
      });
    }
  }, []);

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      title="Filtros Avançados"
      footer={[
        <Button type="primary" ghost onClick={handleCancel}>
          <FormattedMessage id="commons.modal.button.cancel" />
        </Button>,
        <Button type="primary" onClick={onCallback}>
          Pesquisar
        </Button>,
      ]}
      width={1000}
    >
      <Form form={form}>
        <RegisterDataAccountPayable form={form} />

        <FilterByDatesFields />
      </Form>
    </Modal>
  );
};

export default InstallmentsAdvancedModalFilters;
